import { RAISE_API_V1_URL } from "constants/endpoints";
import { post } from "services/api";

export const signUp = async ({
  XSession,
  fingerprint,
  email,
  phone,
  password,
  confirmPassword: password_confirmation,
  referralCode,
  captchaToken
}) => {
  const URL = `${RAISE_API_V1_URL}/users`;

  const headers = {
    "x-session": XSession,
    "device-fingerprint": fingerprint
  };

  const body = {
    user_registration_form: {
      email,
      phone,
      password,
      password_confirmation,
      referral_code: referralCode,
      accept_terms: true
    },
    recaptcha_token: captchaToken
  };

  const response = await post(URL, body, { headers });
  return response.data;
};
